import { render, staticRenderFns } from "./package.vue?vue&type=template&id=cb5ad2e6&scoped=true&"
import script from "./package.vue?vue&type=script&lang=ts&"
export * from "./package.vue?vue&type=script&lang=ts&"
import style0 from "./package.vue?vue&type=style&index=0&id=cb5ad2e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5ad2e6",
  null
  
)

export default component.exports